import { createInvokeEpic } from '../../../signalr/createInvokeEpic'
import { saveBBMISINDefinition } from './definition'

export default createInvokeEpic('bbmisin.saveBBMISIN', saveBBMISINDefinition)
